import { useAppSelector } from 'app/hooks'
import { UseTableRowProps } from 'react-table'
import { useIntl } from 'react-intl'

import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import AuditActionCell from '../AuditTable/auditActionCell'
import { AuditOrangeEmail } from '../AuditTable/styles'
import { AUDIT_HEADERS } from '../consts'
import {
  AuditMobileTableAction,
  AuditMobileTableDataContainer,
  AuditMobileTableLabel,
  AuditMobileTableTitle,
  AuditWhiteCard,
} from '../styles'
import type { DomainLogs } from '../types'
import { auditTableMessages } from '../messages'

interface AuditMobileTableProps {
  values: Record<AUDIT_HEADERS, string | number>
  original: UseTableRowProps<DomainLogs>['original']
}

function AuditMobileTable({
  original,
  original: {
    user: { firstName, lastName, email },
  },
  values: { date, domain },
}: AuditMobileTableProps) {
  const rootDomainId = useAppSelector(currentRootDomainIdSelector)
  const { formatMessage } = useIntl()

  return (
    <AuditWhiteCard>
      <AuditMobileTableAction>
        <AuditActionCell log={original} rootDomainId={rootDomainId || ''} />
      </AuditMobileTableAction>
      <AuditMobileTableDataContainer>
        <AuditMobileTableTitle>
          {formatMessage(auditTableMessages.date)}
        </AuditMobileTableTitle>
        <AuditMobileTableLabel>
          <IntlFormattedDate date={date} withTime />
        </AuditMobileTableLabel>
      </AuditMobileTableDataContainer>
      <AuditMobileTableDataContainer>
        <AuditMobileTableTitle>
          {formatMessage(auditTableMessages.domain)}
        </AuditMobileTableTitle>
        <AuditMobileTableLabel>{domain}</AuditMobileTableLabel>
      </AuditMobileTableDataContainer>
      <AuditMobileTableDataContainer>
        <AuditMobileTableTitle>
          {formatMessage(auditTableMessages.user)}
        </AuditMobileTableTitle>
        <AuditMobileTableLabel>
          <AuditOrangeEmail address={email}>
            {`${lastName}, ${firstName}`}
          </AuditOrangeEmail>
        </AuditMobileTableLabel>
      </AuditMobileTableDataContainer>
    </AuditWhiteCard>
  )
}

export default AuditMobileTable
